import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { Lists, ListsGraphQLQueryResponse, ListsGraphQLQueryVariables } from 'modules/domains/list';
import { useGraphql } from 'utils/hooks/useGraphql';
import { doesExist } from 'utils/tsHelpers';

import { fetchListsWithParamsQuery } from './listQuery';
import { useListsState } from './useListsState';
import { useOffsetState } from './useOffsetState';
import { useTranslation } from '../../../hooks/useTranslation';
import { useFetchListsQueryError } from '../../errorIds';
import { useDisableListsQuery } from './useDisableListsQuery';

export const useAllLists = (listsPerPage = 50) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [lists, addToLists] = useListsState();
  const [offset, incrementOffset] = useOffsetState(listsPerPage);
  const diableListQuery = useDisableListsQuery();

  const {
    data: { lists: fetchedLists } = {},
    isLoading,
    error: isError,
  } = useGraphql<ListsGraphQLQueryResponse<Lists>, ListsGraphQLQueryVariables>(
    fetchListsWithParamsQuery,
    {
      skip: diableListQuery,
      variables: { pagination: { limit: listsPerPage, offset } },
      onError: (error) => {
        dispatch(addNegativeToastWithErrorId(t('apiError.lists'), useFetchListsQueryError, error));
      },
    },
  );

  useEffect(() => {
    if (!isLoading && doesExist(fetchedLists)) {
      addToLists(fetchedLists.results);
      if (fetchedLists.info && offset + listsPerPage < fetchedLists.info.count) incrementOffset();
    }
  }, [fetchedLists, offset, isLoading, listsPerPage]);

  return { lists, isLoading, isError };
};
